import { useCallback, useState } from 'react'
import { readColumnPrefs, toggleColumnId, writeColumnPrefs } from '@/utils/columnPrefs'

/**
 * Visible columns for the All Deployments table, remembered per viewer in
 * localStorage. Storage failures are swallowed: the choice then lasts only for
 * the page view.
 */
export function useColumnPreferences(allIds: readonly string[], defaults: readonly string[]) {
  const [visible, setVisible] = useState<string[]>(() => readColumnPrefs(allIds, defaults))

  const toggle = useCallback(
    (id: string) => {
      const next = toggleColumnId(visible, id, allIds)
      setVisible(next)
      writeColumnPrefs(next)
    },
    [visible, allIds],
  )

  const reset = useCallback(() => {
    const next = allIds.filter((id) => defaults.includes(id))
    setVisible(next)
    writeColumnPrefs(next)
  }, [allIds, defaults])

  const isVisible = useCallback((id: string) => visible.includes(id), [visible])

  return { visible, toggle, reset, isVisible }
}
